<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/DateTime/NewDDateTimeEditor'
export default {
  name: 'NewDBirthdayEditor',
  extends: compoment
}
</script>
